const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '24小时不间断更新，院线大片、热播剧集第一时间同步上线，让你永远快人一步。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站支持1080P与4K超清播放，自适应码率技术确保流畅不卡顿，沉浸式观影体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    desc: '手机、平板、电脑无缝切换，观影记录与收藏实时同步，随时随地想看就看。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无需注册登录即可免费观看，无弹窗广告干扰，纯净观影环境让你专注内容本身。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '涵盖电影、电视剧、综艺、动漫、纪录片等全品类，经典老片与最新热映一应俱全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            五大核心优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-background-50 rounded-xl p-6 md:p-7 text-center transition-all duration-200 hover:bg-background-50 border border-background-200/60 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feat.icon} text-xl md:text-2xl text-primary-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}